<script setup>
import Popin from "@/components/molecules/popin";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Titre from "@/components/atoms/titre";
import erreur from "@/assets/images/fid_illu_erreur.png";

const props = defineProps({
  message: {
    type: String,
    required: false,
    default:
      "Nous ne pouvons pas ajouter cette carte car elle est déjà liée à un compte. Veuillez vérifier que les informations ont été correctement saisies."
  }
});

const popinRef = ref(null);

const show = () => {
  popinRef.value.show();
};

defineExpose({ show });
</script>

<template>
  <Popin
    ref="popinRef"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    size="lg"
  >
    <div class="u-text-center u-font-15">
      <div class="u-mb-sm">
        <LazyImage
          :src="erreur"
          width="112"
          height="65"
          alt=""
          class="u-inline-block"
        />
      </div>
      <Titre
        tag="h2"
        size="md"
      >
        On s'est déjà vu, non ?
      </Titre>
      <p class="u-mx-lg u-mt-md">
        {{ message }}
      </p>
      <div class="u-inline-flex u-mt-md u-flex-column-reverse@md">
        <Button
          variant="primary"
          radius="full"
          size="md"
          class="u-mr-sm u-mr-none@md"
          outline
          to="/infos-et-services/pages-cachees/carte-fidelite-associee-a-un-compte-comment-faire"
          target="_blank"
        >
          Aide
        </Button>
      </div>
    </div>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
